import { createSlice } from '@reduxjs/toolkit';

const signInContentSlice = createSlice({
    name: 'signInContent',
    initialState: {
        signInContent: null, 
    },
    reducers: {
        setSignInContent: (state, action) => {
            state.signInContent = action.payload;
        },
    },
});


export const { setSignInContent } = signInContentSlice.actions;
export default signInContentSlice.reducer;
